// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__2R_xB","itemsSelected":"Header_itemsSelected__2YRsN","Logo":"Header_Logo__3nPU4"};